import { Reply } from "penpal"
import { ProgressInput } from "../../../shared/progress"
import { IfcToLdConfig } from "./ifc-to-ld-config"

// API shared between app and iframe

export const IFC_PROGRESS_STAGES = [
  "download",
  "load-ifc",
  "load-frag",
  "convert-ifc-to-frag",
  "upload-frag",
  "stream-ifc-to-ld",
] as const

export type IfcProgressStage = typeof IFC_PROGRESS_STAGES[number]

export type ParentApi = {
  setProgress: (input: ProgressInput<IfcProgressStage>) => void
}

export type FragToLdInput = {
  fragUri: string
  fragUrl: string
  targetGraphUri: string
  ifcToLdConfig: IfcToLdConfig
}

export type IFrameApi = {
  setIfcUrls: (urls: string[]) => Promise<void>
  setFragmentUrls: (urls: string[]) => Promise<void>
  convertIfcToFrag: (url: string) => Promise<Reply<Uint8Array>>
  convertFragToLd: (input: FragToLdInput) => Promise<Reply<ReadableStream<string>>>
  generateExampleIfcToLdConfig: () => Promise<IfcToLdConfig>
}
